module.exports = __webpack_public_path__ + "static/media/LogicWedge1_4_3.ffe0c792.png";